<template>
    <div class="page explain">
        <h2 style="margin-top: 0.5em;">Speluitleg</h2>
        <!--div class="seperator"></div-->
        <p>Je krijgt straks 10 omgekeerde kaarten te zien.<br />Je mag er 5 omdraaien.<br />Met elk kaartje waar het VakantieVeilingen logo op afgebeeld staat verdien je een extra winkans.</p>
        <p><strong>Maar let op!</strong><br />Er zitten ook kaartjes tussen die geen extra kansen&nbsp;opleveren.</p>
        <p><strong>Minimaal 2 kaartjes goed?</strong> <br/>Dan maak je kans op één van de&nbsp;100&nbsp;hele&nbsp;Staatsloten en maak je ook kans op één van de 4&nbsp;Vakantiepakketten t.w.v.&nbsp;&euro;&nbsp;404,- met een Apple Airpods Pro inclusief &euro;&nbsp;125,- cadeau!</p>

        <router-link to="/game" class="button stl"><span>Begin het spel</span></router-link>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import { TimelineMax } from '@/vendor';

    export default {
        mounted()
        {
            this.$store.dispatch( 'sky', 'darker' );
            this.$store.dispatch( 'sun', 'down' );
        },

        methods: {
            getAnimateIn()
            {
                let tl = new TimelineMax({ delay: 0.5 });

                tl.staggerFrom( '.page.explain > *', 0.5, { y: -50, opacity: 0 }, 0.05 );

                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                tl.to( '.page.explain', 0.3, { y: -50, opacity: 0 });

                return tl;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/pages/Explain.vue